import React, { Component } from 'react';
import PropTypes from 'prop-types';
import styled from 'styled-components';
import classNames from 'classnames';
import isEmpty from 'lodash/isEmpty';
import isEqual from 'lodash/isEqual';
import isFunction from 'lodash/isFunction';
import Checkbox from 'material-ui/Checkbox';
import Colors from '../styles/colors';

class List extends Component {
  constructor(props) {
    super(props);

    const { items } = props;
    this.state = {
      items,
      selectAll: false,
      selectedItems: [],
      error: '',
    };
  }

  componentWillReceiveProps(nextProps) {
    if (!isEqual(nextProps.items, this.props.items)) {
      this.setState({ items: nextProps.items });
    }
  }

  onSelectAll = (_e, isChecked) => {
    const { items } = this.state;
    const selectedItems = isChecked ? [...items] : [];
    this.setState(
      {
        selectAll: isChecked,
        selectedItems,
      },
      this.setStateChangeUpdate
    );
  };

  onSelectItem = item => {
    return (_e, isChecked) => {
      let { items, selectedItems } = this.state;
      if (isChecked) {
        selectedItems.push({ ...item });
      } else {
        // look for the already selectedItems index and remove it
        selectedItems = selectedItems.filter(({ key }) => !isEqual(key, item.key));
      }

      const selectAll = isEqual(items.length, selectedItems.length);
      this.setState(
        {
          selectAll,
          selectedItems,
        },
        this.setStateChangeUpdate
      );
    };
  };

  setStateChangeUpdate = () => {
    const { onStateChange } = this.props;
    const { selectedItems } = this.state;
    onStateChange(selectedItems);
  };

  isItemSelected = item => {
    const { selectedItems } = this.state;

    if (isEmpty(item)) {
      return false;
    }

    const exist = selectedItems.find(({ key }) => isEqual(key, item.key));
    return exist ? true : false;
  };

  isAllItemsSelected = () => {
    const { items, selectedItems } = this.state;
    return isEqual(items.length, selectedItems.length);
  };

  renderBodyList() {
    const { items } = this.state;
    const { editMode, renderEmpty } = this.props;

    if (isEmpty(items)) {
      if (!!renderEmpty && isFunction(renderEmpty)) {
        return renderEmpty();
      }

      return <ListEmpty>Empty List</ListEmpty>;
    }

    return items.map(data => {
      const { key, values } = data;
      return (
        <div className="list-row" key={`item-${key}`}>
          {values.map((value, index) => {
            if (index === 0 && editMode) {
              return (
                <div className="list-item" key={`item-${index}`}>
                  <Checkbox
                    checked={this.isItemSelected(data)}
                    label={value}
                    onCheck={this.onSelectItem(data)}
                    style={{
                      padding: '5px 0',
                    }}
                    labelStyle={{
                      width: '100%',
                      fontSize: '1.6rem',
                      fontWeight: 'normal',
                      lineHeight: '28px',
                      margin: 0,
                    }}
                    iconStyle={{
                      width: 25,
                      height: 25,
                      fill: '#ff8f53',
                      transition: 'none',
                    }}
                  />
                </div>
              );
            }

            const itemClass = classNames('list-item', {
              'padding-four-top': !editMode,
              'padding-four-bottom': !editMode,
            });

            return (
              <div className={itemClass} key={`item-${index}`}>
                {value}
              </div>
            );
          })}
        </div>
      );
    });
  }

  render() {
    const { editMode, headers = [] } = this.props;
    const { items, selectAll } = this.state;

    return (
      <ListWrapper>
        <div className="list-row">
          {headers.map((header, index) => {
            if (index === 0 && editMode) {
              return (
                <div className="list-item" key={`header-${index}`}>
                  <Checkbox
                    checked={selectAll}
                    disabled={isEmpty(items)}
                    label={header}
                    onCheck={this.onSelectAll}
                    labelStyle={{
                      fontSize: '1.6rem',
                      lineHeight: '26px',
                      margin: 0,
                    }}
                    iconStyle={{
                      width: 25,
                      height: 25,
                      fill: '#ff8f53',
                      transition: 'none',
                    }}
                  />
                </div>
              );
            }

            // rest of the headers
            return (
              <div className="list-item font-weight-700" key={`header-${index}`}>
                {header}
              </div>
            );
          })}
        </div>
        <ListBody>{this.renderBodyList()}</ListBody>
      </ListWrapper>
    );
  }
}

const ListWrapper = styled.div`
  .list-row {
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    align-items: center;
    border-bottom: 1px solid ${Colors.lightBorder};
    min-height: 45px;

    &:last-child {
      border-bottom: none;
    }

    .list-item {
      color: ${Colors.fontBlack};
      padding: 8px 10px;
    }
  }
`;

const ListBody = styled.div`
  max-height: 520px;
  overflow-y: auto;
`;

const ListEmpty = styled.div`
  display: flex;
  height: 120px;
  align-items: center;
  justify-content: center;
`;

List.propTypes = {
  headers: PropTypes.array,
  items: PropTypes.array,
  editMode: PropTypes.bool,
  renderEmpty: PropTypes.oneOfType([PropTypes.func, PropTypes.bool]),
  onStateChange: PropTypes.func,
};

List.defaultProps = {
  headers: [],
  items: [],
  editMode: false,
  renderEmpty: false,
  onStateChange: () => {},
};

export default List;
